export const VAULT = 'vault';
export const lifiUrl = "https://li.quest/v1";
export const KEY_STORE = 'keystore';
export const TEMP_MEM_STORE = 'tempmemstore';
export const NON_EVM_VAULT = 'nEVMVault';
export const NON_EVM_LIST = [
    'COSMOS',
    'APTOS',
    'SUI',
    'SOLANA',
    'NEAR',
    'POLKADOT',
    'BITCOIN',
    'NEO',
    'LITECORE',
    'LITECOIN',
];
export const KSTORE = 'keystore';
export const getConfigForShardStorage = (environment) => {
    let DSC_ADDRESS, RPC_URL;
    if (environment == 'mainnet') {
        DSC_ADDRESS = '0xbC0f4112Cd2C78EF20CDF3aDdB13F6cbCcd4B281';
        RPC_URL = 'https://polygon-mainnet.g.alchemy.com/v2/N-B2cfYzTLWt18hLTyCUgU8KOAVdv9HI';
    }
    else if (environment == 'mainnet-staging') {
        DSC_ADDRESS = '0x992f6201AbcB53c9042282E5C4d174cC973C0f3D';
        RPC_URL = 'https://polygon-mainnet.g.alchemy.com/v2/N-B2cfYzTLWt18hLTyCUgU8KOAVdv9HI';
    }
    else if (environment == 'testnet') {
        DSC_ADDRESS = '0x7EDfE250B4416abA5D0306Ae9187702c6b116eab';
        RPC_URL = 'https://polygon-mumbai.g.alchemy.com/v2/Nv3Z8rMhm-LI1pyhRdefrVaacip3T12K';
    }
    return {
        DSC_ADDRESS: DSC_ADDRESS,
        RPC_URL: RPC_URL,
    };
};
const SUBGRAPH_URL = {
    testnet: 'https://api.thegraph.com/subgraphs/name/saurabh-threely/triadids',
    'mainnet-staging': 'https://api.thegraph.com/subgraphs/name/saurabh-threely/indexer-stagingmainnet',
    mainnet: 'https://api.thegraph.com/subgraphs/name/saurabh-threely/indexer-mainnet',
};
export const getSubgraphUrl = (environment = 'mainnet') => {
    return SUBGRAPH_URL[environment];
};
